import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import logo from "../../assets/images/brand/nautilusshipping.jpeg";

import { apiUrl } from "../Settings/Config";

import { showLoader, hideLoader, showAlert } from "../Settings/Settings";
class Login extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.props");
    this.state = {
      fields: {
        username: "",
        password: "",
      },
      error_msg: "",
      redirectTo: "",
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get("token") || "";
    const redirectTo = params.get("redirect") || "";
    this.setState({ redirectTo });
    if (token) {
      this.loginByToken(token);
    }
    console.log(token, "tokentokentokentoken");

    const script = document.createElement("script");
    script.src = "/assets/plugins/sidemenu/sidemenu.js";
    script.async = true;
    document.body.appendChild(script);

    const script2 = document.createElement("script");
    script2.src = "/assets/plugins/p-scroll/pscroll.js";
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.src = "/assets/js/custom.js";
    script3.async = true;
    document.body.appendChild(script3);
    $("#global-loader").fadeOut();
    $("body").addClass("login-img");
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { fields: { [field]: { $set: value } } }));
  };

  handleSignin = () => {
    const formPayload = this.state.fields;
    this.setState({ error_msg: "" });
    var postObject = {
      userName: formPayload.username,
      userPassword: formPayload.password,
    };
    showLoader("do_login", "class");

    axios
      .post(`${apiUrl}user/login`, postObject)
      .then((res) => {
        if (res.data.success === true) {
          var ResulSet = res.data;
          localStorage.setItem("token", ResulSet.token);
          localStorage.setItem("nemouserId", ResulSet.userId);
          localStorage.setItem("permissions", ResulSet.userPermissions);
          localStorage.setItem("userName", ResulSet.userName);
          localStorage.setItem("firstName", ResulSet.firstName);

          setTimeout(() => {
            hideLoader("do_login", "class");
            $("body").removeClass("login-img");
            window.location.href = this.state.redirectTo ? decodeURIComponent(this.state.redirectTo) : "/dashboard";
          }, 1000);
        }
      })
      .catch((error) => {
        console.log(error);
        const errMsg = error?.response?.data?.message ?? error.message;
        hideLoader("do_login", "class");
        showAlert("Error", errMsg, "error");
      });
  };

  loginByToken = (token) => {
    axios
      .post(
        `${apiUrl}user/loginByToken`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((res) => {
        if (res.data.success === true) {
          const ResulSet = res.data;
          localStorage.setItem("token", token);
          localStorage.setItem("nemouserId", ResulSet.userId);
          localStorage.setItem("permissions", ResulSet.userPermissions);
          localStorage.setItem("userName", ResulSet.userName);
          localStorage.setItem("firstName", ResulSet.firstName);
          setTimeout(() => {
            $("body").removeClass("login-img");
           // window.location.href = "/dashboard";
          }, 1000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /* signin - end*/

  render() {
    return (
      <div className="page">
        <div id="global-loader">
          <img src="../assets/images/loader.svg" className="loader-img" alt="Loader" />
        </div>
        <div className="container-login100">
          <div className="wrap-login100 p-6" style={{ minWidth: "550px" }}>
            <form className="login100-form validate-form">
              <div style={{ width: "250px", margin: "0 auto" }}>
                <img src={logo} className="header-brand-img" alt="" />
              </div>
              <span className="login100-form-title pb-5">NEMO</span>
              <div className="panel panel-primary">
                <Form
                  {...this.props}
                  fields={this.state.fields}
                  onChange={this.fieldChange}
                  onValid={this.handleSignin}
                  error_msg={this.state.error_msg}
                  onInvalid={() => console.log("Form invalid!")}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const isEmpty = (value) => (value === "" ? "This field is required." : null);

function validationConfig(props) {
  const { username, password } = props.fields;

  return {
    fields: ["username", "password"],

    validations: {
      username: [[isEmpty, username]],
      password: [[isEmpty, password]],
    },
  };
}

export default Login;

class Form extends Component {
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgUsername = "";
    let errMsgPassword = "";

    if ($validation.username.error.reason !== undefined) {
      errMsgUsername = $validation.username.show && <span className="error">{$validation.username.error.reason}</span>;
    }
    if ($validation.password.error.reason !== undefined) {
      errMsgPassword = $validation.password.show && <span className="error">{$validation.password.error.reason}</span>;
    }

    return (
      <div className="panel-body tabs-menu-body p-0 pt-5">
        <div className="validate-input input-group" data-bs-validate="Valid email is required: ex@abc.xyz">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
            }}
            className="input-group-text bg-white text-muted"
          >
            <i className="zmdi zmdi-email text-muted" aria-hidden="true"></i>
          </a>
          <input
            className="input100 border-start-0 form-control ms-0"
            type="text"
            placeholder="UserName"
            value={fields.username}
            tabIndex={1}
            {...$field("username", (e) => onChange("username", e.target.value))}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }
            }}
          />
          {errMsgUsername}
        </div>
        <div className="validate-input input-group" id="Password-toggle">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
            }}
            className="input-group-text bg-white text-muted"
          >
            <i className="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
          </a>
          <input
            className="input100 border-start-0 form-control ms-0"
            type="password"
            placeholder="Password"
            value={fields.password}
            tabIndex={2}
            {...$field("password", (e) => onChange("password", e.target.value))}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }
            }}
          />
          {errMsgPassword}
        </div>
        <div className="container-login100-form-btn">
          <a
            href="/"
            className="login100-form-btn btn-primary do_login"
            id="do_login"
            onClick={(e) => {
              e.preventDefault();
              this.props.$submit(onValid, onInvalid);
            }}
          >
            Login
          </a>
        </div>
      </div>
    );
  }
}
Form = validated(validationConfig)(Form);
